import { createFileRoute } from '@tanstack/react-router';

import { PaperScreen } from '../../features/paper/paper-screen';
import { parsePaperSearch } from '../../features/paper/paper-search';

/**
 * `/mylab/paper` — S7 논문 (E14 §2). 추천·수집 두 모드가 한 경로의 두 보기다(S7 §2 · D137).
 *
 * 라우트는 얇게 둔다: 화면은 `features/paper`·`features/highlight`에 있다. 게이트는 부모
 * `mylab.tsx`가 맡는다. 모드·찾기·인접 상세 선택은 search param에 싣는다(E14 §3·§5).
 */
export const Route = createFileRoute('/mylab/paper')({
  validateSearch: parsePaperSearch,
  component: PaperScreen,
});
